import { render, staticRenderFns } from "./BulletinUpload.vue?vue&type=template&id=b1b807de&"
import script from "./BulletinUpload.vue?vue&type=script&lang=js&"
export * from "./BulletinUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports